import { inject, Service } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { ConfirmationModalComponent } from '@modals';
import type { MbmButtonVariant } from '@components';

export interface ConfirmationOptions {
  titleKey?: string;
  subtitleKey?: string;
  messageKey: string;
  messageParams?: Record<string, unknown>;
  confirmTextKey?: string;
  cancelTextKey?: string;
  confirmVariant?: MbmButtonVariant;
}

@Service()
export class ConfirmationService {
  private readonly modalController = inject(ModalController);

  async confirmAsync(options: ConfirmationOptions): Promise<boolean> {
    const modal = await this.modalController.create({
      component: ConfirmationModalComponent,
      componentProps: {
        titleKey: options.titleKey ?? 'general.confirmation',
        subtitleKey: options.subtitleKey,
        messageKey: options.messageKey,
        messageParams: options.messageParams ?? {},
        confirmTextKey: options.confirmTextKey ?? 'general.confirm',
        cancelTextKey: options.cancelTextKey ?? 'general.cancel',
        confirmVariant: options.confirmVariant ?? 'primary',
      },
    });

    await modal.present();
    const { role } = await modal.onWillDismiss();
    return role === 'confirm';
  }

  /** Info popup with a single close button. */
  async alertAsync(options: Pick<ConfirmationOptions, 'titleKey' | 'messageKey' | 'messageParams' | 'confirmTextKey'>): Promise<void> {
    const modal = await this.modalController.create({
      component: ConfirmationModalComponent,
      componentProps: {
        titleKey: options.titleKey ?? 'general.confirmation',
        messageKey: options.messageKey,
        messageParams: options.messageParams ?? {},
        confirmTextKey: options.confirmTextKey ?? 'general.close',
        hideCancel: true,
      },
    });

    await modal.present();
    await modal.onWillDismiss();
  }
}
